import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.png'; // Import your logo image here
import Translate from '../Translate/Translate';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();

  // const toggleMenu = () => {
  //   setIsMenuOpen(!isMenuOpen);
  // };

  // const toggleDropdown = () => {
  //   setIsDropdownOpen(!isDropdownOpen); // Toggle dropdown visibility
  // };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src={logo} alt="UlsaApp Logo" className="navbar-logoimg" />
      </div>

      {/* Authentication Buttons */}
      <div className="auth-buttons">
        <Translate />
        <button className="login-button" onClick={() => navigate('/login')}>Sign In</button>
      </div>    
    </nav>
  );
};

export default Navbar;
